<template>
  <layout>
    <template slot="header">
      <span v-if="profile.deliveryChannel.includes('In-app')">
        Notification settings
      </span>
      <span v-else-if="profile.deliveryChannel.includes('SMS')">
        Sms notifications
      </span>
      <span v-else-if="profile.deliveryChannel.includes('Email')">
        Email notifications
      </span>
      <span v-else-if="profile.deliveryChannel.includes('WhatsApp')">
        WhatsApp notifications
      </span>
    </template>
    <template>
      <v-list dense>
        <form-subheader class="px-4">General</form-subheader>
        <v-radio-group v-model="findEl('settingsPreference').value">
          <v-radio
            class="custom-label d-flex flex-row-reverse px-4 mb-6 cursor"
            value="all"
          >
            <template v-slot:label>
              <v-icon class="mr-6">mdi-volume-high</v-icon>
              All notifications
            </template>
          </v-radio>
          <v-radio
            class="custom-label d-flex flex-row-reverse px-4 mb-6 cursor"
            value="favourites"
          >
            <template v-slot:label>
              <v-icon class="mr-6"> mdi-star</v-icon>
              Favorites only
            </template>
          </v-radio>
          <v-radio
            class="custom-label d-flex flex-row-reverse px-4 cursor"
            value="mute"
          >
            <template v-slot:label>
              <v-icon class="mr-6">mdi-volume-off</v-icon>
              Mute all
            </template>
          </v-radio>
        </v-radio-group>
        <form-subheader class="px-4 mb-5"
          >Only deliver notifications which</form-subheader
        >
        <v-combobox
          class="px-4"
          hide-selected
          deletable-chips
          hide-no-data
          label="Include tags"
          v-model="findEl('settingsIncludeTags').value"
          chips
          multiple
        >
          <template v-slot:item="{ item }">
            {{ item.name }}
          </template>
          <template v-slot:selection="data">
            <v-chip
              small
              @click:close="handleClose(findEl('settingsIncludeTags').value, data.index)"
              color="primary"
              close
              close-icon="mdi-close-circle"
            >
              {{ data.item }}
            </v-chip>
          </template>
        </v-combobox>
        <v-combobox
          class="px-4"
          hide-selected
          deletable-chips
          hide-no-data
          label="Exclude tags"
          v-model="findEl('settingsExcludeTags').value"
          chips
          multiple
        >
          <template v-slot:item="{ item }">
            {{ item.name }}
          </template>
          <template v-slot:selection="data">
            <v-chip
              small
              @click:close="handleClose(findEl('settingsExcludeTags').value, data.index)"
              color="primary"
              close
              close-icon="mdi-close-circle"
            >
              {{ data.item }}
            </v-chip>
          </template>
        </v-combobox>
        <template v-if="profile.deliveryChannel.includes('In-app')">
          <form-subheader class="px-4">
            Options
          </form-subheader>
          <div class="d-flex align-center mx-0 px-4 mb-6">
            <div style="font-size: 16px">
              Sound in the app
            </div>
            <v-spacer />
            <v-switch
              data-test-switch="settingsSoundInTheApp"
              v-model="findEl('settingsSoundInTheApp').value"
              class="ma-0"
              hide-details
            ></v-switch>
          </div>
        </template>
      </v-list>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text color="text-primary" @click.stop="close">
        Cancel
      </v-btn>
      <v-btn text color="primary" depressed :loading="isLoading" @click="save">
        Save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import FormSubheader from '@/components/FormSubheader';
import { ref, onMounted } from '@vue/composition-api';
import useObjects from '@/api/objects';
import useAuth from '@/api/auth';

export default {
  name: 'NotificationSettings',
  props: ['show', 'profile'],
  components: {
    Layout,
    FormSubheader
  },
  setup(props, { emit }) {
    const general = ref('all');
    const showOtherNoty = ref(false);
    const emailNoty = ref(false);
    const isLoading = ref(false);
    const userId = ref('');
    const smsNoty = ref(false);
    const snackbar = ref(false);
    let properties = ref([
      {
        key: 'settingsPreference',
        value: 'all'
      },
      {
        key: 'settingsIncludeTags',
        value: []
      },
      {
        key: 'settingsExcludeTags',
        value: []
      },
      {
        key: 'settingsSoundInTheApp',
        value: false
      }
    ]);
    const { object } = useObjects();
    const { loadProfileAsync } = new useAuth();

    function findEl(key) {
      return properties.value.find(el => el.key === key);
    }

    function close() {
      emit('close');
    }

    function save() {
      let propertiesSend = properties.value.map(el => ({
        value: el.value,
        propertyId: el.id
      }));
      isLoading.value = true;
      object
        .updateObjectPropertiesNoCache({
          propertiesArray: propertiesSend
        })
        .then(() => {
          return loadProfileAsync();
        })
        .then(() => {
          close();
        })
        .finally(() => {
          isLoading.value = false;
        });
    }

    function handleClose(data, index) {
      data.splice(index, 1);
    }

    onMounted(() => {
      loadProfileAsync().then(() => {
        properties.value = props.profile.objectProperties.map(item => ({
          id: item.id,
          value: item.value,
          key: item.key
        }));
      });
    });

    return {
      general,
      close,
      save,
      showOtherNoty,
      emailNoty,
      smsNoty,
      properties,
      isLoading,
      findEl,
      snackbar,
      handleClose
    };
  }
};
</script>

<style lang="scss">
.theme--light.custom-label .v-label {
  color: rgba(0, 0, 0, 0.87);
}

.theme--dark.custom-label .v-label {
  color: #ffffff;
}

.cursor {
  cursor: pointer;
}
</style>
